export default __webpack_public_path__ + "static/media/Stamp3.886ebbbd.svg";